<template>
  <div>
    <div class="header-container">
      <div class="flex">
        <div class="left-name" :style="{ paddingLeft: '40px' }">
          易筑后台管理系统
          <!--          <div class="logo-container" v-if="showLogo">-->
          <!--            <el-image :src="logo" lazy />-->
          <!--          </div>-->
        </div>
      </div>
      <div class="flex header-right">
        <el-autocomplete
          popper-class="my-autocomplete"
          size="small"
          class="inline-input"
          v-model="searchWork"
          :fetch-suggestions="querySearch"
          placeholder="搜索菜单"
          :trigger-on-focus="false"
          @select="handleSelect"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
          <template slot-scope="{ item }">
            <div class="alias">{{ item.name }}({{ item.alias }})</div>
          </template>
        </el-autocomplete>
        <help-list />
        <div style="position: relative">
          <el-badge :value="tipsNum" class="badgeitem" :max="99" :hidden="tipsNum == 0">
            <el-button type="text" @click="showAllTips" class="helpSet" style="margin: 0 30px 0 0; position: relative">
              <i class="iconfont icon-back-xiaoxi" />
              <p>消息</p>
            </el-button>
          </el-badge>
        </div>
        <!-- <el-popover placement="bottom-end" width="250" trigger="manual" v-model="visible" :visible-arrow="false">
          <div class="tips-content">
            <div class="tips-top">
              您有 <span style="color: #ff0000">{{ tipsNum }}</span
              >条未读消息，是否处理？
            </div>
            <div class="tips-bottom">
              <el-button type="text" @click="visible = false">忽略</el-button>
              <el-button type="text" @click="showAllTips">查看</el-button>
            </div>
          </div>

        </el-popover> -->
        <el-popover popper-class="header-popper" width="120px" trigger="click">
          <template slot="reference">
            <div class="flex usernameBox">
              <img :src="userPhoto" />
              <span>{{ currentUser && currentUser.user ? currentUser.user.fullname : '' }}</span>
              <i class="el-icon-arrow-down" />
            </div>
          </template>
          <template>
            <div>
              <div>
                <ul class="user-link-ul">
                  <li @click="openInfoDialog">个人信息</li>
                  <li @click="openResetPwdDialog">修改密码</li>
                  <!--                  <li @click="handleStyleSettingDialog">风格设置</li>-->
                  <li @click="logout">退出系统</li>
                </ul>
              </div>
            </div>
          </template>
        </el-popover>
      </div>
    </div>
    <eco-sidebar-dialog
      destroy-on-close
      width="28%"
      title="风格设置"
      append-to-body
      :visible="styleSettingDialogVisible"
      :before-close="handleStyleSettingDialogClose"
    >
      <el-form :model="styleSetting" style="margin-left: -30px; padding: 20px">
        <eco-form-item label="标签页风格" label-width="100px">
          <el-radio-group v-model="styleSetting.tabsStyle.tabType">
            <el-radio-button label="card">选项卡样式</el-radio-button>
            <el-radio-button label>默认样式</el-radio-button>
            <el-radio-button label="border-card">卡片化</el-radio-button>
            <el-radio-button label="menuSetting">菜单配置</el-radio-button>
          </el-radio-group>
        </eco-form-item>
      </el-form>
    </eco-sidebar-dialog>
    <eco-sidebar-dialog
      destroy-on-close
      title="查看个人信息"
      :visible="infoDialogVisible"
      width="28%"
      append-to-body
      :before-close="handleStyleSettingDialogClose"
    >
      <el-form v-if="currentUser && currentUser.user" :inline="true" ref="form" label-width="80px" size="mini" style="padding: 20px">
        <el-form-item label="用户名称" style="width: 50%">
          <span class="content_span">{{ currentUser.user.fullname }}</span>
        </el-form-item>
        <el-form-item label="用户账号">
          <span class="content_span">{{ currentUser.user.account }}</span>
        </el-form-item>
        <el-form-item label="手机号码" style="width: 50%">
          <span class="content_span">{{ currentUser.user.mobile }}</span>
        </el-form-item>
        <el-form-item label="邮箱地址">
          <span class="content_span">{{ currentUser.user.email }}</span>
        </el-form-item>
        <el-form-item label="用户性别" style="width: 50%">
          <span class="content_span">{{ currentUser.user.sex }}</span>
        </el-form-item>
        <el-form-item label="用户状态">
          <span class="content_span">{{
            currentUser.user.status == '1' ? '正常' : currentUser.user.status == '0' ? '禁用' : currentUser.user.status == '-1' ? '未激活' : '离职'
          }}</span>
        </el-form-item>

        <el-form-item label="家庭地址" style="width: 100%">
          <span class="content_span">{{ currentUser.user.address }}</span>
        </el-form-item>
        <el-form-item style="width: 100%" label="所属角色">
          <template v-for="name in currentUser.role">
            <el-tag type="warning" size="small" :key="name" v-if="name">{{ name }}</el-tag>
          </template>
        </el-form-item>
        <el-form-item style="width: 100%" label="所属岗位">
          <el-tooltip :content="post.pathName" placement="top" :key="post.postId" v-for="post in currentUser.post">
            <el-tag type="success" size="small">{{ post.postName }}</el-tag>
          </el-tooltip>
        </el-form-item>
        <el-form-item style="width: 100%" label="所属组织">
          <el-tooltip :content="org.pathName" placement="top" :key="org.orgId" v-for="org in currentUser.org">
            <el-tag size="small">{{ org.orgName }}</el-tag>
          </el-tooltip>
        </el-form-item>
      </el-form>
    </eco-sidebar-dialog>
    <eco-sidebar-dialog
      destroy-on-close
      title="修改密码"
      :visible.sync="modifyPwdDialogVisible"
      :close-on-click-modal="false"
      width="28%"
      append-to-body
      id="modlfy-dialog"
      :before-close="handleStyleSettingDialogClose"
    >
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" label-width="120px" size="mini" style="padding: 20px">
        <el-form-item label="旧密码" prop="old">
          <el-input type="password" v-model="pwdForm.old" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new">
          <el-input type="password" placeholder="请输入新密码" v-model="pwdForm.new"></el-input>
        </el-form-item>
        <el-form-item label="重复新密码" prop="newRepeat">
          <el-input type="password" placeholder="请再次输入新密码" v-model="pwdForm.newRepeat"></el-input>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button size="small" @click="modifyPwdDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm()">确认</el-button>
      </div>
    </eco-sidebar-dialog>
    <el-drawer
      title="消息中心"
      :visible.sync="tipsVisible"
      class="sideDrawer notification-drawer sideDrawerNopadBottom"
      size="40%"
      :before-close="handleClose"
      :append-to-body="true"
      destroy-on-close
      :wrapperClosable="false"
      :close-on-press-escape="false"
    >
      <div class="notification-content">
        <div class="top-tabs">
          <div class="left-button">
            <el-tabs v-model="isRead" class="demo-tabs" @tab-click="handleClickread">
              <el-tab-pane name="noread">
                <template #label>
                  <span>{{ noreadText }}</span>
                </template>
              </el-tab-pane>
              <el-tab-pane name="read">
                <template #label>
                  <span>{{ readText }}</span>
                </template></el-tab-pane
              ></el-tabs
            >
          </div>
          <div v-if="isRead == 'noread' && allTips.length" class="set-read">
            <el-button @click="setRead(1)">本页已读</el-button>
            <!-- <el-button @click="setRead(2)">全部已读</el-button> -->
          </div>
        </div>
        <div class="bottom-contetn">
          <div class="left-tabs">
            <el-tabs v-model="activeName" class="demo-tabs" tab-position="left" @tab-click="handleClick">
              <el-tab-pane name="first">
                <template #label>
                  <svg aria-hidden="true" class="icon svg-icon iconStyle">
                    <use xlink:href="#icon-suoyouxiaoxi"></use>
                  </svg>
                  <span class="textT">所有消息({{ messageCount.messCount }})</span>
                </template>
              </el-tab-pane>
              <el-tab-pane name="second">
                <template #label>
                  <svg aria-hidden="true" class="icon svg-icon iconStyle">
                    <use xlink:href="#icon-xitongxiaoxi"></use>
                  </svg>
                  <span class="textT">系统消息({{ messageCount.systemCount }})</span>
                </template>
              </el-tab-pane>
              <el-tab-pane name="fifth">
                <template #label>
                  <svg aria-hidden="true" class="icon svg-icon iconStyle">
                    <use xlink:href="#icon-xitonggonggao"></use>
                  </svg>
                  <span class="textT">系统公告({{ messageCount.announcementCount }})</span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="right-content">
            <div v-if="allTips.length > 0" class="notification-detail">
              <div v-for="(item, index) in allTips" :key="index" class="notification-items">
                <div class="top-text">
                  <div v-if="isRead == 'noread'" class="red-circle"></div>
                  <el-tooltip popper-class="notificationClass" effect="dark" placement="top">
                    <template #content> {{ item.content }}</template>
                    <div class="textF" @click="showNoticeDetail(item.id)"><div v-html="item.content"></div></div>
                  </el-tooltip>
                </div>
                <div class="bottom-text">
                  <div class="textS">{{ item.owner }}</div>
                  <div class="textS">{{ item.createTime }}</div>
                </div>
              </div>
            </div>
            <div v-else class="notification-detail center-style">
              <figure>
                <img src="@/assets/img/no-notification.svg" />
                <figcaption style="margin-top: -17px; margin-left: 5px">
                  {{
                    activeName == 'first'
                      ? '暂无消息'
                      : activeName == 'second'
                      ? '暂无系统消息'
                      : activeName == 'third'
                      ? '暂无预警提醒'
                      : activeName == 'forth'
                      ? '暂无风险提醒'
                      : activeName == 'fifth'
                      ? '暂无系统公告'
                      : ''
                  }}
                </figcaption>
              </figure>
            </div>
            <div class="page-bean">
              <el-pagination
                :currentPage="currentPage"
                :page-size="10"
                :pager-count="5"
                :total="total"
                background
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <notice-detail :show="detailShow" :form="form" @close="close"></notice-detail>
  </div>
</template>

<script>
import noticeDetail from '@/views/system/components/noticeDetail.vue'
import FeAvatar from '@/components/common/FeAvatar.vue'
import LangSelect from '@/components/lang/LangSelect.vue'
import helpList from '@/components/helpList/index.vue'
import screenfull from 'screenfull'
import { mapState } from 'vuex'
import { setWsSocket, wsRtnConnect, wsSubCancel, wsSocketCancel } from '@/socks'
import { Notification } from 'element-ui'

export default {
  name: 'navigator',
  components: { FeAvatar, LangSelect, helpList, noticeDetail },
  props: ['menuShow'],
  data() {
    var validateNew = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      }
      let config = this.pwdStrategy
      if (config.enable == 1) {
        let pwdRule = config.pwdRule
        let pwdLength = config.pwdLength
        if (pwdRule) {
          if (value.length < pwdLength) {
            callback(new Error('新密码长度至少为' + pwdLength))
          } else if (pwdRule == 2) {
            var re = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])')
            if (!re.test(value)) {
              callback(new Error('新密码必须包含数字、字母'))
            } else {
              callback()
            }
          } else if (pwdRule == 3) {
            var re = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])')
            if (!re.test(value)) {
              callback(new Error('新密码必须包含数字、字母、特殊字符'))
            } else {
              callback()
            }
          } else if (pwdRule == 4) {
            var re = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9])')
            if (!re.test(value)) {
              callback(new Error('新密码必须包含数字、大小字母、特殊字符'))
            } else {
              callback()
            }
          }
        }
      } else {
        if (value.length < 6) {
          callback(new Error('新密码长度至少为6'))
        } else {
          callback()
        }
      }
    }
    var validateold = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入旧密码'))
      } else {
        callback()
      }
    }
    var validateNewReapeat = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else {
        callback()
      }
    }
    return {
      visible: false,
      logo: require('@/assets/img/h_logo.png'),
      showLogo: true,
      isScreenFull: false,
      styleSettingDialogVisible: false,
      styleSetting: {
        tabsStyle: {
          tabPosition: 'top',
          tabType: 'border-card'
        },
        elementUI: {
          theme: 'day-theme'
        }
      },
      searchWork: '',
      searchMenus: [],
      infoDialogVisible: false,
      modifyPwdDialogVisible: false,
      pwdForm: {
        old: '',
        new: '',
        newRepeat: ''
      },
      pwdRules: {
        old: [{ validator: validateold, trigger: 'blur' }],
        new: [{ validator: validateNew, trigger: 'blur' }],
        newRepeat: [{ validator: validateNewReapeat, trigger: 'blur' }]
      },
      isIeExplorer: false,
      allTips: [],
      tipsContent: [],
      tipsVisible: false,
      activeName: 'first',
      tipsNum: 0,
      stompClient: null,
      messageCount: {
        announcementCount: 0,
        messCount: 0,
        noReadMessCount: 0,
        noRiskCount: 0,
        noWarningCount: 0,
        riskCount: 0,
        systemCount: 0,
        warningCount: 0
      },
      noreadText: '',
      readText: '',
      selectedVal: [],
      num: 0,
      isRead: 'noread',
      detailShow: false,
      form: {},
      total: 0,
      pageSize: 10,
      currentPage: 1,
      isHover: false,
      userPhoto: ''
    }
  },
  computed: {
    ...mapState({
      menus: (state) => state.menu.menus,
      currentUser: (state) => state.user.currentUserDetail,
      token: (state) => state.login.currentUser.token,
      frontUrl: function () {
        if (this.currentUser && this.currentUser.user && this.currentUser.user.account) {
          return `${window.context.front}?token= ` + this.token
        } else {
          return `${window.context.front}`
        }
      },
      pwdStrategy: (state) => state.user.pwdStrategy
    })
  },
  watch: {
    styleSetting: {
      handler: function (val, oldval) {
        let str = JSON.stringify(val)
        localStorage.setItem('styleSetting', str)
        this.$store.dispatch('styleSetting/actionStyleSetting', JSON.parse(str))
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  },
  methods: {
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.showAllTips()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.showAllTips()
    },
    getAllDataDict() {
      this.$store.dispatch('user/getAllDataDict')
      this.$store.dispatch('user/getAllEnumerate')
      this.$store.dispatch('user/getTaxTypeEnum')
    },
    getTipsStatusNum2(activeName) {
      let level = ''
      if (activeName == 'second') {
        level = '1'
      }
      if (activeName == 'third') {
        level = '2'
      }
      if (activeName == 'forth') {
        level = '3'
      }
      if (activeName == 'fifth') {
        level = '4'
      }
      this.noreadText = '未读消息（0）'
      this.readText = '已读消息（0）'
      this.$http.get('${portal}/innermsg/messageReceiver/v1/getMessBoxInfoByLevel?client=platform&level=' + level).then((res) => {
        this.messageCount.messCount = res.data.readMessCountTotal
        this.messageCount.systemCount = res.data.systemCount
        this.messageCount.warningCount = res.data.warningCount
        this.messageCount.riskCount = res.data.riskCount
        this.messageCount.announcementCount = res.data.announcementCount
        this.noreadText = '未读消息（' + res.data.noReadMessCount + '）'
        this.readText = '已读消息（' + res.data.readMessCount + '）'
      })
    },
    //获取消息数量
    getTipsStatusNum(activeName) {
      let level = ''
      if (activeName == 'second') {
        level = '1'
      }
      if (activeName == 'third') {
        level = '2'
      }
      if (activeName == 'forth') {
        level = '3'
      }
      if (activeName == 'fifth') {
        level = '4'
      }
      this.noreadText = '未读消息（0）'
      this.readText = '已读消息（0）'
      this.$http.get('${portal}/innermsg/messageReceiver/v1/getMessBoxInfoByLevel?client=platform&level=' + level).then((res) => {
        this.tipsNum = res.data.noReadMessCount
        this.messageCount.messCount = res.data.noReadMessCountTotal
        this.messageCount.systemCount = res.data.noSystemCount
        this.messageCount.warningCount = res.data.noWarningCount
        this.messageCount.riskCount = res.data.noRiskCount
        this.messageCount.announcementCount = res.data.noAnnouncementCount
        this.noreadText = '未读消息（' + res.data.noReadMessCount + '）'
        this.readText = '已读消息（' + res.data.readMessCount + '）'
      })
    },
    isShowPover() {
      this.$http.get('${portal}/innermsg/messageReceiver/v1/getMessBoxInfoByLevel?client=saas&level=').then((res) => {
        this.tipsNum = res.data.noReadMessCount
        if (this.tipsNum > 0) {
          this.visible = true
        }
      })
    },
    handleClickread(tab) {
      this.isRead = tab.name
      this.currentPage = 1
      this.activeName = 'first'
      this.showAllTips()
    },
    //选中内容
    handleSelectionChange(val) {
      this.selectedVal = val
      this.num = this.selectedVal.length
    },
    //全选 取消选中
    toggleSelection(rows, refs) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs[refs].toggleRowSelection(row)
        })
      } else {
        this.$refs[refs].clearSelection()
      }
    },
    clearTips() {
      this.$http.get('${portal}/innermsg/messageReceiver/v1/readed').then((res) => {
        if (res.data.state) {
          this.getTipsStatusNum()
          this.showMessage()
        }
      })
    },
    //标记已读
    setRead(type) {
      if (type == 1) {
        let params = ''
        this.allTips.forEach((item) => {
          params += item.id + ','
        })
        params = params.substring(0, params.length - 1)
        this.$http.post('${portal}/innermsg/messageReceiver/v1/readByIds', params).then((res) => {
          if (res.data.state) {
            this.showAllTips()
          } else {
            this.$message.error('标记已读失败！')
          }
        })
      } else {
        let param = {
          querys: [
            {
              group: 'main',
              operation: 'EQUAL',
              property: 'msgLevel',
              relation: 'AND',
              value:
                this.activeName == 'first'
                  ? ''
                  : this.activeName == 'second'
                  ? '1'
                  : this.activeName == 'third'
                  ? '2'
                  : this.activeName == 'forth'
                  ? '3'
                  : this.activeName == 'fifth'
                  ? '4'
                  : ''
            }
          ]
        }
        this.$http.post('${portal}/innermsg/messageReceiver/v1/readAllByUserId', param).then((res) => {
          if (res.data.state) {
            this.showAllTips()
          } else {
            this.$message.error('标记已读失败！')
          }
        })
      }
    },
    //删除消息通知
    delNotice() {
      if (this.selectedVal && this.selectedVal.length > 0) {
        let params = {
          ids: ''
        }
        this.selectedVal.forEach((item) => {
          params.ids += item.id + ','
        })
        params.ids = params.ids.substring(0, params.ids.length - 1)
        this.$http.remove('${portal}/innermsg/messageReceiver/v1/remove?ids=' + params.ids).then((res) => {
          if (res.data.state) {
            this.showAllTips()
            this.$refs.tipsTable.clearSelection()
          } else {
            this.$message.error('删除失败！')
          }
        })
      } else {
        this.$message.info('请先选择数据！')
      }
    },
    //查看系统公告详情
    showNoticeDetail(id) {
      if (id) {
        this.$http.get('${portal}/innermsg/messageReceiver/v1/get?id=' + id).then((res) => {
          if (res.data) {
            this.form = res.data
            this.detailShow = true
            this.showAllTips()
          }
        })
      }
    },
    //关闭公告详情
    close() {
      this.detailShow = false
    },
    handleClose() {
      this.tipsVisible = false
      this.activeName = 'first'
    },
    showMessage() {
      this.tipsContent = []
      let params = {
        querys: [
          {
            group: 'main',
            operation: 'EQ',
            property: 'read',
            relation: 'AND',
            value: '1'
          },
          {
            group: 'main',
            operation: 'EQ',
            property: 'client',
            relation: 'AND',
            value: 'platform'
          }
        ]
      }
      this.$http.post('${portal}/innermsg/messageReceiver/v1/list', params).then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          this.tipsContent = res.data.rows
        }
      })
    },
    handleClick(tab) {
      this.activeName = tab.name
      this.currentPage = 1
      this.showAllTips(false)
    },
    getNotice(params) {
      this.allTips = []
      this.$http.post('${portal}/innermsg/messageReceiver/v1/list', params).then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          res.data.rows.forEach((item) => {
            if (item.msg_level == 4) {
              item.content = item.subject
            }
            if (item.owner == '超级管理员') {
              item.owner = '易筑网络'
            }
          })
          this.allTips = res.data.rows
        }
      })
    },
    showAllTips(flag = true) {
      if (flag) {
        if (this.isRead == 'noread') this.getTipsStatusNum(this.activeName)
        else this.getTipsStatusNum2(this.activeName)
      }
      this.allTips = []
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: this.total
        },
        querys: [
          {
            group: 'main',
            operation: 'EQ',
            property: 'read',
            relation: 'AND',
            value: this.isRead == 'noread' ? '1' : '2'
          },
          {
            group: 'main',
            operation: 'EQ',
            property: 'client',
            relation: 'AND',
            value: 'platform'
          },
          {
            group: 'main',
            operation: 'EQ',
            property: 'msgLevel',
            relation: 'AND',
            value:
              this.activeName == 'first'
                ? ''
                : this.activeName == 'second'
                ? '1'
                : this.activeName == 'third'
                ? '2'
                : this.activeName == 'forth'
                ? '3'
                : this.activeName == 'fifth'
                ? '4'
                : ''
          }
        ]
      }
      this.$http.post('${portal}/innermsg/messageReceiver/v1/list', params).then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          res.data.rows.forEach((item) => {
            if (item.msg_level == 4) {
              item.content = item.subject
            }
            if (item.owner == '超级管理员') {
              item.owner = '易筑网络'
            }
          })
          this.allTips = res.data.rows
        }
        this.total = res.data.total
      })
      this.tipsVisible = true
    },
    linkTo(val) {
      // if (val.detail_url) {
      //   this.activeName = 'first'
      //   this.tipsVisible = false
      //   let aimName = val.detail_url.replace('/', '')
      //   this.$router.push({ name: aimName })
      //   this.$http.get('${portal}/innermsg/messageReceiver/v1/get?id=' + val.id).then((res) => {
      //     this.getTipsStatusNum()
      //   })
      // }
    },
    submitForm() {
      this.$refs['pwdForm'].validate((valid) => {
        if (valid) {
          this.$http
            .post('${uc}/api/user/v1/user/changUserPsd', {
              oldPwd: this.pwdForm.old,
              newPwd: this.pwdForm.new
            })
            .then((resp) => {
              let data = resp.data
              if (data && data.state) {
                this.$message.success('修改密码成功')
                this.modifyPwdDialogVisible = false
              }
            })
        }
      })
    },
    openInfoDialog() {
      this.infoDialogVisible = true
    },
    openResetPwdDialog() {
      this.$store.dispatch('user/getDefPwdStrategy')
      this.modifyPwdDialogVisible = true
      if (this.$refs['pwdForm']) {
        this.$refs['pwdForm'].resetFields()
      }
    },
    handleMenuCollapse() {
      this.$emit('update:menuShow', !this.menuShow)
    },
    logout() {
      let loginRouthPath = localStorage.getItem(sessionStorage.getItem('loginAccount') + 'loginRoutePath') || '/login'
      this.$store.dispatch('menu/actionMenusEmpty')
      this.$store.dispatch('login/logoutAndCleanUp').then(() => {
        switch (window.ssoConfig.mode) {
          case 'cas':
            window.sessionStorage.removeItem('currentUser')
            sessionStorage.clear()
            window.location.href = window.ssoConfig.logout + '?service=' + window.location.href.split('?')[0]
            break
          case 'oauth':
            break
          default:
            this.$router.push({
              name: 'tenantLogin',
              params: {
                tenant: sessionStorage.getItem('tenantCode')
              }
            })
            break
        }
      })
    },
    handleScreenFull(type) {
      if (!screenfull.isEnabled) {
        this.$message({
          message: '不支持全屏',
          type: 'warning'
        })
        return false
      }
      screenfull.toggle()
      this.isScreenFull = !this.isScreenFull
    },
    handleStyleSettingDialog() {
      let styleSetting = localStorage.getItem('styleSetting')
      if (styleSetting && styleSetting != 'null') {
        this.styleSetting = JSON.parse(styleSetting)
      }
      this.styleSettingDialogVisible = true
    },
    handleStyleSettingDialogClose() {
      this.styleSettingDialogVisible = false
      this.infoDialogVisible = false
      this.modifyPwdDialogVisible = false
    },
    querySearch(queryString, cb) {
      // 查询出二级三级的菜单
      let menus = []
      menus = [...this.menus]
      if (queryString) {
        this.searchMenus = []
        this.preFilterMenus(this.menus, queryString)
      } else {
        this.searchMenus = menus
      }
      // 调用 callback 返回建议列表的数据
      this.searchMenus = this.searchMenus.unique('alias')
      cb(this.searchMenus)
    },
    preFilterMenus(menus, queryString) {
      if (menus instanceof Array) {
        menus.forEach((x) => {
          this.filterMenus(x, queryString)
        })
      } else {
        this.filterMenus(menus, queryString, true)
      }
    },
    filterMenus(x, queryString, isComponent) {
      if (x.children) {
        let r = x.children.filter((menu) => {
          this.preFilterMenus(menu, queryString)
          return menu.name.toLowerCase().indexOf(queryString.toLowerCase()) != -1 || menu.alias.toLowerCase().indexOf(queryString.toLowerCase()) != -1
        })
        if (r && r.length >= 1) {
          r.forEach((y) => {
            if (isComponent) {
              y.parentComponent = x
            }
            this.searchMenus.push(y)
          })
        }
      }
    },
    handleSelect(item) {
      if (!item.parentComponent) {
        this.$router.push({ path: `/${item.alias}` })
      } else {
        this.$router.push({
          path: `/${item.parentComponent.alias}#${item.alias}`
        })
      }
    },
    showUserPhoto() {
      if (this.currentUser && this.currentUser.user && this.currentUser.user.photo) {
        this.$store.dispatch('menu/downloadImg', this.currentUser.user.photo).then((res) => {
          if (res != '') {
            this.userPhoto = res
          } else {
            this.userPhoto = window.location.origin + '/img/defaultPhoto.jpg'
          }
        })
      } else {
        this.userPhoto = window.location.origin + '/img/defaultPhoto.jpg'
      }
    }
  },
  mounted() {
    // !this.currentUser && this.$store.dispatch('user/loadCurrentUserDetail')
    const currentUser = this.$store.state.login.currentUser
    if (currentUser) {
      this.isShowPover()
      this.getTipsStatusNum()
      this.showUserPhoto()
      const test = false
      let config = {}
      if (test) {
        let atu =
          'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsInRlbmFudElkIjoiLTEiLCJleHAiOjE2MjczNDkxOTMsImlhdCI6MTYyNzI2Mjc5M30.w_pWGFoA-amNPE4nsW3NPw9tSTNGigAdte-Raq9bFNc9zNYw7TQF7Dk6kd4QJiImE1gREdfpZnqhPSM0lVFoCw'
        config = {
          Authorization: atu,
          url: 'http://192.168.0.109:8303/ws',
          destination: '/user/message/1366923611046285312'
        }
      } else {
        config = {
          Authorization: this.$store.state.login.currentUser.token,
          url: window.context.websocket + '/ws',
          destination: `/user/message/${this.$store.state.login.currentUser.userId}`
        }
      }
      setWsSocket(config).then((res) => {
        this.stompClient = res
        // 多个destination 根据destination做赋值
        wsRtnConnect(res, config.destination).then((resp) => {
          if (resp.data) {
            this.getTipsStatusNum()
            // this.$message.info(JSON.parse(resp.data).content);
            Notification.success({
              title: '消息提醒',
              dangerouslyUseHTMLString: true,
              message: JSON.parse(resp.data).subject
            })
          }
        })
      })
      this.getAllDataDict()
      let currentUser = this.$store.state.login.currentUser
      if (currentUser) {
        this.$store.dispatch('login/setCurUser', currentUser.account)
        // 获取下老系统jwt
        this.$store.dispatch('login/loginV2Token', currentUser.account)
        this.$store.dispatch('login/actionLoginAccount', currentUser.account)
        const tenantId = currentUser.tenantId
        if (tenantId && tenantId != '-1') {
          let _this = this
          let url = '${uc}/uc/tenantManage/v1/getJson?id=' + tenantId
          this.$http.get(url).then(
            (resp) => {
              if (resp.data) {
                this.getTipsStatusNum()
                let tenantManage = resp.data
                if (tenantManage.manageLogo) {
                  let manageLogo = JSON.parse(tenantManage.manageLogo)
                  if (manageLogo && manageLogo.length > 0) {
                    _this.showLogo = true
                    _this.logo = window.context.portal + '/system/file/v1/downloadFile?fileId=' + manageLogo[0].id
                  }
                }
                if (tenantManage.name) {
                  _this.$store.dispatch('tenant/actionTenantName', tenantManage.name)
                }
              }
            },
            (error) => {
              reject(error)
            }
          )
        } else {
          this.showLogo = false
        }
      } else {
        this.showLogo = false
      }
    } else {
      this.showLogo = false
    }
  },
  created() {
    let USER_AGENT = navigator.userAgent.toLowerCase()
    let isChrome = /.*(chrome)\/([\w.]+).*/
    if (!isChrome.test(USER_AGENT)) {
      this.isIeExplorer = true
    }
  },
  beforeDestroy() {
    wsSocketCancel(this.stompClient)
  },
  destroyed() {
    wsSocketCancel(this.stompClient)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/element-variables.scss';
.header-container {
  padding: 0 10px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .flex {
    .left-title {
      margin-right: 10px;
    }
    .left-name {
      color: #333333;
      font-weight: 600;
      font-size: 16px;
      .logo-container {
        display: flex;
        .el-image {
          height: 48px;
        }
      }
    }
  }
  .header-right {
    /deep/.inline-input input {
      border-radius: 16px;
      background: #f3f4f6;
      border: 0;
    }
  }
  .helpSet.el-button--text,
  .helpSet.el-button--text:hover,
  .helpSet.el-button--text:focus {
    color: unset;
  }
  .helpSet.el-button--text i {
    color: #8c8c90 !important;
    font-size: 18px;
  }
  .helpSet.el-button--text p {
    color: #333 !important;
    font-size: 10px;
    line-height: 14px;
    margin: 0;
  }
  .usernameBox {
    padding-right: 20px;
    cursor: pointer;
    img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      margin-right: 8px;
    }
    span {
      width: 60px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 17px;
      margin-right: 10px;
    }
    i {
      font-size: 12px;
      color: #8c8c90;
    }
  }
  .tip_number {
    background: red;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    right: 3px;
  }
}

.badgeitem {
  /deep/.el-badge__content.is-fixed {
    right: 40px;
    top: 10px;
  }
}
.notification-drawer {
  .top-tabs {
    height: 48px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: space-between;
    /deep/.el-tabs__header {
      margin: 9px 0 0;
    }
    /deep/.el-tabs__nav-wrap::after {
      display: none;
    }
  }
  .left-button {
    margin-left: 20px;
  }
  .bottom-contetn {
    height: calc(100% - 48px);
    display: flex;
    flex-direction: row;
  }
  .left-tabs {
    width: 180px;
  }
  .right-content {
    width: calc(100% - 180px);
    background: rgba(242, 243, 245, 1);
  }
  .notification-detail {
    padding: 0 10px 10px 10px;
    height: calc(100% - 63px);
    max-height: calc(100% - 63px);
    overflow-y: auto;
  }
  .page-bean {
    margin-top: 10px;
    display: flex;
    justify-content: right;
  }
  .notification-items {
    margin-top: 10px;
    height: 47px;
    padding: 15px 14px 14px 16px;
    background: #fff;
  }
  .bottom-text {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .top-text {
    display: flex;
    flex-direction: row;
  }
  .textF {
    text-align: left;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #393b3e;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    cursor: pointer;
  }
  .textS {
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #8c8c90;
    line-height: 17px;
  }
  .red-circle {
    margin-right: 2px;
    margin-left: -6px;
    height: 6px;
    width: 6px;
    background: #ff453a;
    border-radius: 13px;
  }
  .red-circle-tabs {
    margin-top: 10px;
    height: 6px;
    width: 6px;
    background: #ff453a;
    border-radius: 13px;
  }
  .tips-circle {
    width: 6px;
    height: 49px;
  }
  .iconStyle {
    font-size: 20px;
    margin-right: 10px;
    width: 20px;
    position: relative;
    top: 3px;
    height: 20px;
  }
  .textT {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    flex: 1;
    line-height: 22px;
  }
  .center-style {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .set-read {
    height: 48px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }
}
.notification-title {
  margin-bottom: 20px;
  font-size: 20px;
  font-family:
    PingFangSC-Semibold,
    PingFang SC;
  font-weight: 600;
  color: #232323;
  text-align: center;
}
.bottom-button {
  margin-top: 40px;
}
</style>
<style>
.user-link-ul {
  list-style: none;
  margin: 0;
  padding: 4px 0;
}
.user-link-ul li {
  width: 120px;
  height: 32px;
  background: #fff;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #393b3e;
  line-height: 32px;
}
.user-link-ul li:hover {
  background: #e8f0fa;
}
.header-popper {
  min-width: unset !important;
}

.notification-drawer {
  height: 100%;
}
.modal {
  height: calc(100% - 48px);
  margin-top: 48px;
}
.notification-content {
  height: calc(100% - 10px);
  width: 100%;
}
.notification .el-drawer__body {
  padding: 0;
}
.notification .el-tabs__header {
  height: 48px;
  margin: 0;
}
.notification .el-tabs .el-tabs__nav-wrap::after {
  display: none;
}
.notification .el-tabs__item {
  height: 49px;
  line-height: 48px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.notification .el-tabs__active-bar {
  bottom: 2px;
}
.notification .el-tabs__item.is-active {
  font-size: 16px;
  font-weight: 600;
  color: #393b3e;
}
.bottom-contetn .el-tabs__item {
  height: 49px;
  line-height: 47px;
  width: 180px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.bottom-contetn .el-tabs--left .el-tabs__item.is-left {
  text-align: left;
}
.bottom-contetn .el-tabs__item.is-active {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  background: rgba(242, 243, 245, 1);
}
.bottom-contetn .el-tabs--left .el-tabs__active-bar.is-left {
  display: none;
}
.bottom-contetn .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  display: none;
}
.notification .el-button > span {
  font-size: 12px;
}
.notificationClass {
  max-width: calc(100vw / 3 - 100px);
}
</style>

<style scoped>
.content-style {
  max-height: calc(100vh - 400px);
  overflow-y: auto;
  text-align: left;
  margin-bottom: 20px;
}
.active:hover {
  color: var(--el-color-primary);
  cursor: pointer;
}
.content-style >>> p {
  width: 100% !important;
}
.content-style >>> img {
  overflow: hidden;
  width: 100% !important;
}
</style>
